import { API_ENDPOINTS } from "../api-endpoints";
import { HttpClient } from "../http-client";
import {
  challengeByIdInterface,
  challengesDataInterface,
  ChallengesInterface,
  UserChallengesInterface,
} from "../types/types";

export const Badges = {
  createBadges: (body: any) => {
    return HttpClient.post<any>(API_ENDPOINTS.Badges, body);
  },

  GetBadgesData: (options?: any) => {
    return HttpClient.get<any>(
      API_ENDPOINTS.Badges,
      options
    );
  },
  GetUserChallengesData: (options?: any) => {
    return HttpClient.get<any>(
      API_ENDPOINTS.USER_CHALLENGES,
      options
    );
  },
  GetBadgesById: (id?: number) => {
    return HttpClient.get<any>(
      `${API_ENDPOINTS.Badges}/${id}`
    );
  },
  UpdateBadges: (body: any, id: number) => {
    return HttpClient.put<any>(
      `${API_ENDPOINTS.Badges}/${id}`,
      body
    );
  },
  deleteBadges: (id: number) => {
    return HttpClient.delete(`${API_ENDPOINTS.Badges}/${id}`);
  },
};
